export interface FAQEntry {
  id: number;
  question: string;
  answer: string;
  enteredBy: string;
  enteredAt: Date;
  tags: string[];
}
